// extracted by mini-css-extract-plugin
module.exports = {"button":"adButton_button__3aNxc"};